import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const ThemeCtx = createContext({ theme: "midnight", setTheme: () => {} });

const VALID_THEMES = ["midnight", "deep-slate", "indigo-night", "daylight"];

function applyTheme(theme) {
  const t = VALID_THEMES.includes(theme) ? theme : "midnight";
  try {
    document.documentElement.setAttribute("data-theme", t);
  } catch (_) {}
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState("midnight");

  const setTheme = useCallback((t) => {
    setThemeState(t);
    applyTheme(t);
  }, []);

  useEffect(() => {
    let cancelled = false;
    api.get("/settings")
      .then(({ data }) => {
        if (cancelled) return;
        const t = data?.theme || "midnight";
        setThemeState(t);
        applyTheme(t);
      })
      .catch(() => applyTheme("midnight"));

    return () => { cancelled = true; };
  }, []);

  return (
    <ThemeCtx.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export const useTheme = () => useContext(ThemeCtx);
